import type { RobotsSnapshot } from "../../shared/types";

export interface RobotsRuleLine {
  directive: "user-agent" | "allow" | "disallow" | "sitemap";
  value: string;
}

export interface RobotsUiSummary {
  statusLabel: string;
  hasBody: boolean;
  userAgents: string[];
  allowRules: string[];
  disallowRules: string[];
  sitemapUrls: string[];
  rawRules: RobotsRuleLine[];
}

export function summarizeRobots(robots: RobotsSnapshot | undefined): RobotsUiSummary | undefined {
  if (!robots) {
    return undefined;
  }

  const rawRules: RobotsRuleLine[] = [];
  for (const rawLine of robots.body.split(/\r?\n/)) {
    const line = stripComment(rawLine).trim();
    if (!line) {
      continue;
    }

    const separatorIndex = line.indexOf(":");
    if (separatorIndex === -1) {
      continue;
    }

    const key = line.slice(0, separatorIndex).trim().toLowerCase();
    const value = line.slice(separatorIndex + 1).trim();
    if (key === "user-agent" || key === "allow" || key === "disallow" || key === "sitemap") {
      rawRules.push({ directive: key, value });
    }
  }

  return {
    statusLabel: robots.status ? String(robots.status) : "取得不可",
    hasBody: robots.body.trim().length > 0,
    userAgents: uniqueValues(rawRules.filter((rule) => rule.directive === "user-agent").map((rule) => rule.value)),
    allowRules: uniqueValues(rawRules.filter((rule) => rule.directive === "allow").map((rule) => rule.value)),
    disallowRules: uniqueValues(rawRules.filter((rule) => rule.directive === "disallow").map((rule) => rule.value)),
    sitemapUrls: uniqueValues([
      ...robots.sitemapUrls,
      ...rawRules.filter((rule) => rule.directive === "sitemap").map((rule) => rule.value)
    ]),
    rawRules
  };
}

function uniqueValues(values: string[]): string[] {
  return [...new Set(values.filter(Boolean))];
}

function stripComment(line: string): string {
  const index = line.indexOf("#");
  return index >= 0 ? line.slice(0, index) : line;
}
